import { usersService } from '../../services';

export const personMock = async (document) => {
    return await usersService.getPersonByDocument(document);
};
